module.exports = __webpack_public_path__ + "img/hero_unknow.97932e54.webp";